import React from "react";
import {
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Avatar,
  Button,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt, FaUser } from "react-icons/fa";
import { useAuth } from "../../contexts/AuthContext";

export default function UserMenu() {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const hoverBg = useColorModeValue("gray.100", "whiteAlpha.200");

  if (!isAuthenticated) return null;

  const displayName =
    [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
    user?.phone ||
    "کاربر";

  const handleLogout = () => {
    logout();
    navigate("/auth/login");
  };

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={Button}
        variant="ghost"
        borderRadius="full"
        p={1}
        minW="auto"
        h="auto"
        aria-label="منوی کاربر"
        _hover={{ bg: hoverBg }}
        _active={{ bg: hoverBg }}
      >
        <Avatar size="sm" name={displayName} />
      </MenuButton>
      <MenuList zIndex={2000} minW="220px" py={2}>
        <Box px={4} py={2} mb={1}>
          <Text fontWeight="bold" fontSize="sm">
            {displayName}
          </Text>
          {user?.phone && (
            <Text fontSize="xs" color="gray.500" mt={1}>
              {user.phone}
            </Text>
          )}
        </Box>
        <MenuDivider />
        <MenuItem
          icon={<FaUser />}
          onClick={() => navigate("/profile")}
          borderRadius="md"
          mx={2}
        >
          پروفایل
        </MenuItem>
        <MenuItem
          icon={<FaSignOutAlt />}
          onClick={handleLogout}
          color="red.500"
          borderRadius="md"
          mx={2}
          _hover={{ bg: "red.50" }}
        >
          خروج از سیستم
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
